import React from 'react';
import { connect } from 'react-redux';
import { firstError } from '@/utils/errors';
import findResult from '@/utils/resultsHelper';
import { readStates, states } from '@/constants/lifecycle';
import { newUserGroupUrl } from '@/constants/urls';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';

const DuplicateUserGroupAction = ({
  isEditing,
  userGroup,
  newUserGroupCode,
  readErrors,
  readStatus,
}) => (
  <RibbonMenu
    className="aridhia-duplicate-usergroup-action"
    disabled={readStatus !== states.SUCCESS || firstError(readErrors) !== null || isEditing}
    icon="clone"
    message="actions.duplicate"
    name="duplicate"
    url={newUserGroupUrl(userGroup, newUserGroupCode, '#')}
  />
);

const mapStateToProps = ({
  userGroups: {
    userGroups,
    newUserGroupCode,
  },
}, { category, code }) => {
  const userGroup = findResult(userGroups, category, code) || readStates;

  return {
    newUserGroupCode,
    readErrors: userGroup.readErrors,
    readStatus: userGroup.readStatus,
    userGroup,
  };
};

export default connect(mapStateToProps)(DuplicateUserGroupAction);
